import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import type { UserSummary } from "./types";
import { USERS_LIST_QUERY_KEY, USER_DETAIL_QUERY_KEY } from "./constants";

async function deactivateUser(id: string): Promise<UserSummary> {
  return httpClient<UserSummary>(`/api/admin/users/${encodeURIComponent(id)}/deactivate`, {
    method: "POST",
  });
}

export function useDeactivateUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deactivateUser,
    onSuccess: (_data, id) => {
      queryClient.invalidateQueries({ queryKey: USERS_LIST_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: [...USER_DETAIL_QUERY_KEY, id] });
    },
  });
}
